import { MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import _isDate from 'lodash-es/isDate';
import { environment } from '@environment';
import { formatDate } from '@shared/core/utils';
import { Inject, Injectable, Optional } from '@angular/core';
import parse from 'date-fns/parse';

export const CUSTOM_DATE_FORMAT = {
  parse: {
    dateInput: environment.serverDateFormat,
  },
  display: {
    dateInput: 'd MMMM yyyy',
    monthYearLabel: 'MMMM yyyy',
    dateA11yLabel: 'd MMMM yyyy',
    monthYearA11yLabel: 'LLLL yyyy',
  },
};

@Injectable()
export class MaterialDateAdapter extends NativeDateAdapter {
  constructor(@Optional() @Inject(MAT_DATE_LOCALE) private matDateLocale: string) {
    super(matDateLocale);
    super.setLocale(matDateLocale);
  }

  deserialize(value): Date {
    if (!value) {
      return null;
    }

    return _isDate(value) ? value : parse(value, environment.serverDateFormat, new Date());
  }

  format(date: Date, displayFormat: string): string {
    return formatDate(date, displayFormat, this.locale);
  }

  getFirstDayOfWeek(): number {
    return 1;
  }
}
